import React from 'react';

import { Box } from '~/components/blocks';
import { LineVisitorAppointmentDetailFragment } from '~/graphql/generated/graphql';
import { theme } from '~/styles/theme';

import { LineVisitorProfile } from './LineVisitorProfile';

type Props = {
  appointment: LineVisitorAppointmentDetailFragment;
};

export const ReceptionPane = React.memo((props: Props) => {
  const { appointment } = props;

  return (
    <Box position="relative" height="100%" overflow="auto">
      <Box padding={theme.space.l} overflow="auto">
        <LineVisitorProfile appointment={appointment} />
      </Box>
    </Box>
  );
});

ReceptionPane.displayName = 'ReceptionPane';
